import { render, staticRenderFns } from "./NoAccessDisclaimer.vue?vue&type=template&id=4d5db168&scoped=true&"
import script from "./NoAccessDisclaimer.vue?vue&type=script&lang=js&"
export * from "./NoAccessDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./NoAccessDisclaimer.vue?vue&type=style&index=0&id=4d5db168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5db168",
  null
  
)

export default component.exports